import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationModalServiceService } from 'src/app/@services/confirmation-modal-service.service';
import { AnalyticsCookieList, Cookie_Setting_Key, MarketingCookieList, UnclassifiedCookieList } from 'src/app/global-data/commonData';
import { commonFunctions } from 'src/app/global-data/commonFunction';

@Component({
  selector: 'app-cookie-settings-modal',
  templateUrl: './cookie-settings-modal.component.html',
  styleUrls: ['./cookie-settings-modal.component.scss']
})
export class CookieSettingsModalComponent implements OnInit {

  cookieModal = {
     analytics:true,
     marketing:true,
     unclassified: true
   }

   @Input() inPage = false;
   mView = false;

  constructor(
    private dialog : MatDialog,
    private commonFunctions: commonFunctions,
    private matDialogRef: MatDialogRef<CookieSettingsModalComponent>,
    private confirmationModal: ConfirmationModalServiceService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    if(this.cookieService.get(Cookie_Setting_Key)){
      this.cookieModal = JSON.parse(this.cookieService.get(Cookie_Setting_Key))
    }
    if (window.innerWidth < 768) {
      this.mView = true
     
    } else {
      this.mView = false
    }
  }

  close(value = false){
  
    if(this.inPage){
      this.confirmationModal.open('add','Updated Successfully',null,'Your cookie preferences are saved successfully.')
    }else {
        this.matDialogRef.close(value)
    }

    this.deleteDisabledCookies()

  }

  acceptAllCookie(){
      this.cookieModal.analytics = true;
      this.cookieModal.marketing = true;
      this.cookieModal.unclassified = true;
     
      this.commonFunctions.setCookie(Cookie_Setting_Key,JSON.stringify(this.cookieModal),365)
      this.close(true);
  }

  saveOnlyNecessary(){
     this.cookieModal.analytics = false;
      this.cookieModal.marketing = false;
      this.cookieModal.unclassified = false;
     
      this.commonFunctions.setCookie(Cookie_Setting_Key,JSON.stringify(this.cookieModal),365)
      this.close(true);
  }

  savePreferences(){
     this.commonFunctions.setCookie(Cookie_Setting_Key,JSON.stringify(this.cookieModal),365)
      this.close(true);
  }

  deleteDisabledCookies(){

    window['blockedCookies'] = [];
    let cookies = JSON.parse(this.cookieService.get(Cookie_Setting_Key));

    if(!cookies.analytics){
      window['blockedCookies'] = [...window['blockedCookies'],...AnalyticsCookieList];
    }
    if(!cookies.marketing){
      window['blockedCookies'] = [...window['blockedCookies'],...MarketingCookieList];
    }
      if(!cookies.unclassified){
      window['blockedCookies'] = [...window['blockedCookies'],...UnclassifiedCookieList];
    }

    let cookieList = JSON.parse(this.cookieService.get(Cookie_Setting_Key))

    for(let key in cookieList){

      if(key == 'analytics' && !cookieList[key]){
        console.log('delete - ',AnalyticsCookieList)
        AnalyticsCookieList.forEach(cookieKey => {
         
          // this.cookieService.delete(cookieKey);
          document.cookie = `${cookieKey}=; Max-Age=0; path=/;`
        })

      }
      if(key == 'marketing' && !cookieList[key]){
          console.log('delete - ',MarketingCookieList)
        MarketingCookieList.forEach(cookieKey => {
         
          document.cookie = `${cookieKey}=; Max-Age=0; path=/;`
        })

        // this.cookieService.delete(Cookie_Setting_Key)
      }
       if(key == 'unclassified' && !cookieList[key]){
        console.log('delete - ',UnclassifiedCookieList)
        UnclassifiedCookieList.forEach(cookieKey => {
          
          document.cookie = `${cookieKey}=; Max-Age=0; path=/;`
        })

      }


    }

  }

}
